import React from 'react';
import shortid from 'shortid';
import { Pagination } from 'react-bootstrap';
import useVendingMachine from './hooks';
import LandingHeader from './utils/landing-header';
import Header from '../../../components/layout/header/landing';
import RenderCard from './utils/vm-card';
import DataListHandler from '../../../components/layout/body/data-list-handler';
import { ALPHABET } from '../../../components/atoms/const';
import RenderPagination from '../../../components/molecules/pagination';

function VendingMachine() {
  const {
    searchValue, setSearchValue, vm, page, initial, isCoffee, isWholesale,
  } = useVendingMachine();

  let myTitle = '';
  if (!isCoffee && !isWholesale) myTitle = 'Vending Machine';
  else if (!isWholesale) myTitle = 'Coffee Machine';
  else myTitle = 'Wholesale Distribution';

  return (
    <div className="py-4">
      <Header title={myTitle} />
      <div className="px-4 px-xl-5">
        <LandingHeader
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          isCoffee={isCoffee || isWholesale}
        />
        <div className="fz-14 mb-1">Sort by alphabet :</div>
        <Pagination className="d-flex flex-wrap justify-content-start w-100 mb-4">
          <Pagination.Item
            onClick={() => {
              page.setCurrent(1);
              initial.setCurrent('ALL');
            }}
            active={initial.current === 'ALL'}
          >
            <div style={{ minWidth: 25, minHeight: 20 }} className="flexible-center">ALL</div>
          </Pagination.Item>
          {ALPHABET.map((char) => (
            <Pagination.Item
              key={char}
              onClick={() => {
                page.setCurrent(1);
                initial.setCurrent(char);
              }}
              active={initial.current === char}
            >
              <div
                style={{
                  minWidth: 10, maxWidth: 10, width: 10, minHeight: 20,
                }}
                className="flexible-center"
              >
                {char}
              </div>
            </Pagination.Item>
          ))}
        </Pagination>
        <DataListHandler
          isData={!!vm.list && !!vm.list.length}
          isLoading={vm.load}
        >
          <div className="row">
            {vm.list?.map((data) => (
              <div key={shortid.generate()} className="col-lg-6 mb-4">
                <RenderCard
                  vmData={data}
                  refetch={vm.refetch}
                  isCoffee={isCoffee || isWholesale}
                />
              </div>
            ))}
          </div>
        </DataListHandler>
        <div className="d-flex justify-content-md-end justify-content-center mt-4 w-100">
          <RenderPagination
            currentPage={page.current}
            setCurrentPage={page.setCurrent}
            totalPage={vm.totalPage}
          />
        </div>
      </div>
    </div>
  );
}

export default VendingMachine;
